import clsx from "clsx";
import { createElement, FC, HTMLAttributes } from "react";

type Variant = "heading-lg" | "heading-md" | "heading-sm" | "heading-xs";
type Color = "primary" | "secondary" | "white";

interface HeadingProps extends HTMLAttributes<HTMLHeadingElement> {
  className?: string;
  level?: 1 | 2 | 3 | 4 | 5 | 6;
  variant?: Variant;
  color?: Color;
}

const VARIANT_CLASSES: Record<Variant, string> = {
  // 36 / 40 px
  "heading-lg": "text-4xl/10 font-bold",  // fs 2.25 rem  · lh 2.5 rem
  // 30 / 36 px
  "heading-md": "text-3xl/9  font-bold",  // fs 1.875 rem · lh 2.25 rem
  // 24 / 32 px
  "heading-sm": "text-2xl/8  font-bold",  // fs 1.5 rem   · lh 2 rem
  // 20 / 28 px
  "heading-xs": "text-xl/7   font-bold",  // fs 1.25 rem  · lh 1.75 rem
};

const COLOR_CLASSES: Record<Color, string> = {
  primary: "text-zinc-950 dark:text-white",
  secondary: "text-zinc-500 dark:text-zinc-400",
  white: "text-white",
};

export const Heading: FC<HeadingProps> = ({
  className,
  level = 1,
  variant = "heading-xs",
  color = "primary",
  ...props
}) => {
  const tag = `h${level}` as keyof JSX.IntrinsicElements;

  return createElement(tag, {
    ...props,
    className: clsx(
      VARIANT_CLASSES[variant],
      COLOR_CLASSES[color],
      className,
    ),
  });
};

export const Subheading: FC<HeadingProps> = ({
  className,
  level = 2,
  ...props
}) => {
  const tag = `h${level}` as keyof JSX.IntrinsicElements;

  return createElement(tag, {
    ...props,
    className: clsx(
      className,
      "text-base/7 font-semibold text-zinc-950 sm:text-sm/6 dark:text-white"
    ),
  });
};
